module.exports = __webpack_public_path__ + "media/images/components/c01-page-header/c01--welcome/wave--lg-e43e84f5b5cc4ae975dc337744332b4b.svg";